const prefix = "NOTIFICATIONS_";

export const STATE_RESET = prefix + "STATE_RESET";
export const SHOW_NOTIFICATION = prefix + "SHOW_NOTIFICATION";
export const HIDE_NOTIFICATION = prefix + "HIDE_NOTIFICATION";
